<template>
    <div class="data_select">
        <div class="data_select_list">
            <div class="data_select_item">
                <div class="item_name">
                    <el-tooltip  effect="dark" content="筛选列表各维度的数据（可拖拽修改位置）" placement="top-start">
                        <i class="el-icon-question pointer ml4"/>
                    </el-tooltip>
                    筛选
                </div>
                <Draggable ghost-class="drag-ghost"  class="item_list" v-model="showConditionList" draggable=".select_item" :group="{ name: 'condition'}" @end="() => onEnd('conditionCheckList', hideConditionList, showConditionList)">
                    <div v-for="item in showConditionList" :key="item.display_name" class="select_item ellipsis" 
                        @click="handleEditCondition(item)"
                        :class="{ 'is-exclude': item.isExclude }"
                    >
                        <p class="ellipsis" :title="item.title">
                            {{ item.display_name }}
                            <template v-if="item.sub_text && loadingData.conditionLoading !== item.name">：<div class="info">{{item.sub_text}}</div></template>
                            <template v-else><i class="el-icon-loading"/></template>
                        </p>
                        <span  @click.stop="handleCheckChange(false, 'conditionCheckList', item)">X</span>
                    </div>
                    <template v-if="conditionCheckList.length > showMaxOption">
                        <el-popover placement="bottom-end" width="200" trigger="click">
                            <Draggable ghost-class="drag-ghost" class="popover-drag" v-model="hideConditionList" draggable=".select_item"
                                        :group="{ name: 'condition' }"
                                        @end="() => onEnd('conditionCheckList', hideConditionList, showConditionList)">
                                <template v-for="(item) in hideConditionList">
                                    <!--  -->
                                    <div :key="item.display_name" class="select_item ellipsis" 
                                            @click="handleEditCondition(item)">
                                        <p class="ellipsis" :title="item.title">
                                            {{ item.display_name }}
                                            <template v-if="item.sub_text&& loadingData.conditionLoading !== item.name">：<div class="info">{{item.sub_text}}</div></template>
                                             <template v-else><i class="el-icon-loading"/></template>
                                        </p>
                                        <span
                                            @click.stop="handleCheckChange(false, 'conditionCheckList', item)">X</span>
                                    </div>
                                </template>
                            </Draggable>
                            <el-button size="mini" type="primary" plain slot="reference">+{{ conditionCheckList.length - showMaxOption }}</el-button>
                        </el-popover>
                    </template>
                </Draggable>
                <PopoverSelectData 
                    :list="conditionList"
                    :check-list="conditionCheckList"
                    @item-click="(data)=>handleAddCondition( data )"
                >
                    <div  class="el-icon-circle-plus pointer pointer-icon ver-middle" ></div>
                </PopoverSelectData>
            </div>

            <div class="data_select_item">
                <div class="item_name">
                    <el-tooltip  effect="dark" content="选择的维度分组会在列表增加表头，并且数据按照该维度和顺序进行切割。（此处可拖拽切换维度顺序）" placement="top-start">
                        <i class="el-icon-question pointer ml4"/>
                    </el-tooltip>
                    维度
                </div>
                <Draggable ghost-class="drag-ghost" class="item_list" v-model="showDimensionList" draggable=".select_item"
                    :group="{ name: 'dimension' }"
                    @end="() => onEnd('dimensionCheckList', hideDimensionList, showDimensionList)">
                    <div v-for="item in showDimensionList" :key="item.display_name" class="select_item ellipsis"
                        @click="handleEditDimension(item)">
                        <p class="ellipsis" :title="item.title" >
                            {{ item.display_name }}
                            <template v-if="item.sub_text">：<div class="info">{{item.sub_text}}</div></template>
                        </p>
                        <span  @click.stop="handleCheckChange(false, 'dimensionCheckList', item)">X</span>
                    </div>
                    <template v-if="dimensionCheckList.length > showMaxOption">
                        <el-popover placement="bottom-end" width="200" trigger="click">
                            <Draggable ghost-class="drag-ghost" class="popover-drag" v-model="hideDimensionList" draggable=".select_item"
                                :group="{ name: 'dimension' }"
                                @end="() => onEnd('dimensionCheckList', hideDimensionList, showDimensionList)">
                                <template v-for="(item) in hideDimensionList">
                                    <div :key="item.display_name" class="select_item ellipsis"
                                        @click="handleEditDimension(item)">
                                        <p class="ellipsis" :title="item.title"  >
                                            {{ item.display_name }}
                                            <template v-if="item.sub_text">：<div class="info">{{item.sub_text}}</div></template>
                                        </p>
                                        <span
                                            @click.stop="handleCheckChange(false, 'dimensionCheckList', item)">X</span>
                                    </div>
                                </template>
                            </Draggable>

                            <el-button size="mini" type="primary" plain
                                slot="reference">+{{ dimensionCheckList.length - showMaxOption }}</el-button>
                        </el-popover>
                    </template>
                </Draggable>
                <PopoverSelectData 
                    :list="dimensionList"
                    :check-list="dimensionCheckList"
                    @item-click="(data)=>updataCheck(true, 'dimensionCheckList', data )"
                >
                    <div  class="el-icon-circle-plus pointer pointer-icon ver-middle" ></div>
                </PopoverSelectData>
            </div>

            <div class="data_select_item">
                <div class="item_name">
                    <el-tooltip  effect="dark" content="选择的指标会在列表增加表头以及数据。（此处可拖拽切换指标顺序）" placement="top-start">
                        <i class="el-icon-question pointer ml4"/>
                    </el-tooltip>
                    指标
                </div>
                <Draggable ghost-class="drag-ghost" class="item_list" v-model="showFieldsList" draggable=".select_item"
                    :group="{ name: 'field' }" @end="() => onEnd('fieldsCheckList', hideFieldsList, showFieldsList)">
                    <template v-for="(item) in showFieldsList">
                        <div 
                            :key="item.display_name" 
                            class="select_item ellipsis" 
                            :title="item.title" 
                        >
                            <p class="ellipsis">{{ item.display_name }}</p>
                            <span   @click.stop="handleCheckChange(false, 'fieldsCheckList', item)">X</span>
                        </div>
                    </template>
                    <template v-if="fieldsCheckList.length > showMaxOption">
                        <el-popover placement="bottom-end" width="200" trigger="click">
                            <Draggable ghost-class="drag-ghost"  class="popover-drag" v-model="hideFieldsList" draggable=".select_item" :group="{ name: 'field' }"
                                @end="() => onEnd('fieldsCheckList', hideFieldsList, showFieldsList)">
                                <template v-for="(item) in hideFieldsList">
                                    <div 
                                        :key="item.display_name" 
                                        class="select_item item_3 ellipsis"
                                        :title="item.title"
                                    >
                                        <p class="ellipsis"> {{ item.display_name }}</p>
                                        <span   @click.stop="handleCheckChange(false, 'fieldsCheckList', item)">X</span>
                                    </div>
                                </template>
                            </Draggable>

                            <el-button size="mini" type="primary" plain slot="reference">+{{ fieldsCheckList.length -
                                showMaxOption }}</el-button>
                        </el-popover>
                    </template>
                </Draggable>
                <PopoverSelectData 
                    :list="fieldsList" 
                    :check-list="fieldsCheckList"
                    @item-click="(data)=>updataCheck(true, 'fieldsCheckList', data )"
                >
                    <div  class="el-icon-circle-plus pointer pointer-icon ver-middle" ></div>
                </PopoverSelectData>
            </div>
            <div class="data_select_handle">
                <div class="data_select_handle_left">
                    <el-button v-matomo="{behaviorCategory: '素材查询分析', name: '已选条件区(查询)' }" size="mini"  type="primary" :loading="loadingData.listLoading" @click="()=>queryList()">查询</el-button>
                    
                    <el-button 
                        v-matomo="{behaviorCategory: '素材查询分析', name: '已选条件区(导出)' }"
                        size="mini" 
                        :loading="loadingData.exportLoading" 
                        @click="()=>exportList()"
                        v-permission="['export']"
                    >
                        导出
                    </el-button>
                    <el-popconfirm
                        v-matomo="{behaviorCategory: '素材查询分析', name: '已选条件区(重置已选条件)' }"
                        title="确定要重置已选条件吗？"
                        @confirm="()=>resetSelectData()"
                    >
                        <el-button class="ml10 mr10" size="mini" slot="reference">重置已选条件</el-button>
                    </el-popconfirm>
                    <el-button v-matomo="{behaviorCategory: '素材查询分析', name: '已选条件区(复制页面)' }" size="mini" @click="()=>copyPage()">复制页面</el-button>
                </div>
                <div class="data_select_handle_right">
                    <el-button v-matomo="{behaviorCategory: '素材查询分析', name: '已选条件区(保存模板)' }" size="mini"  type="primary" @click="handleSaveTempModal">保存模板</el-button>
                    <el-button 
                        size="mini" 
                        type="primary" 
                        @click="()=>useTempModal({ getConditionSubText: global.getConditionSubText, getDimensionSubText: global.getDimensionSubText })"
                     >
                        使用模板
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Draggable from 'vuedraggable';
import { cloneDeep, uniqBy, uniq, throttle, flatten } from 'lodash'
import {  
   
    DIMENSION_NO_FILTER_LIST, 
    DEFAULT_SELECT_MODAL_DATA
} from '../../constant'
import PopoverSelectData from './popoverSelectData.vue'
import { saveTempModal } from '../../modal'

export default {
    components: { Draggable, PopoverSelectData },
    inject: [ 
        'updataCheckList', 'updataCheck', 'conditionModal', 
        'editDimension', 'resetSelectData', 'copyPage', 'useTempModal',
        'getDimensionData', 'getFieldData', 'addTempData', 'defaultParams',
        'queryList', 'exportList', 'loadingData','global'
    ],
    props: {
        conditionCheckList: {
            type: Array,
            default: ()=>[]
        },
        dimensionCheckList: {
            type: Array,
            default: ()=>[]
        },
        fieldsCheckList: {
            type: Array,
            default: ()=>[]
        },
        fieldsList: {
            type: Array,
            default: ()=>[]
        },
        dimensionList: {
            type: Array,
            default: ()=>[]
        },
    },
    data() {
        return {
            hideDimensionList: [], 
            showDimensionList: [],


            hideFieldsList: [],
            showFieldsList: [],

            hideConditionList: [],
            showConditionList: [],

            showMaxOption: 0,
        }
    },
    methods: {
        onEnd(list, hide, show) {
            this.updataCheckList(list, [ ...show, ...hide ])
        },
        handleCheckChange(...args) {
            this.updataCheck(...args)
        },

        handleEditDimension(dimension) {
           this.editDimension(dimension)
        },

        fieldsCheckListFn() {
            this.showFieldsList = this.fieldsCheckList.slice(0, this.showMaxOption)
            this.hideFieldsList = this.fieldsCheckList.slice(this.showMaxOption)
        },
        dimensionCheckListFn() {
            this.showDimensionList = this.dimensionCheckList.slice(0, this.showMaxOption)
            this.hideDimensionList = this.dimensionCheckList.slice(this.showMaxOption)
        },
        conditionCheckListFn(){
            this.showConditionList = this.conditionCheckMapList.slice(0, this.showMaxOption)
            this.hideConditionList = this.conditionCheckMapList.slice(this.showMaxOption)
        },
        resetOptionWidth() {
            const dom = document.querySelector('.data_select_list');
            this.showMaxOption = Number.parseInt((dom.clientWidth - 60 - 160) / 160)
            this.fieldsCheckListFn()
            this.dimensionCheckListFn()
            this.conditionCheckListFn();
        },
        
        handleEditCondition(condition) {
            const callback = (data)=> {
                this.handleCheckChange('replace', 'conditionCheckList', cloneDeep({
					...condition,
					modalData: data
				}));
            }
            this.conditionModal(condition, callback)
        },
        handleAddCondition(condition) {
            condition = { 
                ...condition, 
            };
            const defaultData = DEFAULT_SELECT_MODAL_DATA[`conditionCheckList_${condition.name}`];
            if (defaultData) {
                condition.modalData = { ...defaultData }
            }
            const callback = (data)=> {
                this.handleCheckChange(true, 'conditionCheckList', cloneDeep({
					...condition,
					modalData: data
				}));
                this.handleCheckChange(true, 'dimensionCheckList', condition )
            }
            this.conditionModal(condition, callback)
        },
        // 保存模板
        handleSaveTempModal() {
            const onSubmit = (data, params)=> {
                this.addTempData(data, params)
                vm.close()
            }
            const { vm } = saveTempModal({
                props: {
                    defaultParams: this.defaultParams
                },
                cbs: {
                    onSubmit
                }
            })
        },
       
    },
    computed: {
        conditionList() {
            return this.dimensionList.map((item)=>{
                return {
                    ...item,
                    children: item.children.filter((child)=> {
                        return !DIMENSION_NO_FILTER_LIST.includes(child.name)
                    })
                }
            })
        },
        conditionCheckMapList() {
            return this.conditionCheckList.map(item=> {
                const modalData = item.modalData;
                if (!modalData) {
                    return item
                };
               
                return {
                    ...item,
                    isExclude: modalData.isExclude,
                    
                }
            })
        },
    },
    mounted() {
        console.log(this.global);
        
        const fn = throttle(()=>{
            this.resetOptionWidth()
        }, 300)
        window.addEventListener('resize', fn)
        this.$once('hook:beforeDestroy', () => {
            window.removeEventListener('resize', fn)
        });
        this.$nextTick(() => {
            this.resetOptionWidth()
        })
    },
    watch: {
        conditionCheckList() {
            this.conditionCheckListFn()
        },
        dimensionCheckList() {
            this.dimensionCheckListFn()
        },
        fieldsCheckList() {
            this.fieldsCheckListFn()
        },
    }
}
</script>

<style lang="scss" scoped>
.popover-drag {
    max-height: 400px;
    overflow: auto;
    width: 190px;
}
.select_item {
    width: 160px;
    margin: 5px;
    padding: 3px 5px;
    color: #000;
    position: relative;
    border: 1px solid #81d3f8;
    background-color: #d2effc;
    cursor: pointer;
    p {
        padding-right: 24px;
        line-height: 16px;
        .info {
            display: inline;
            color: #999;
        }
    }
    span {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        text-align: center;
        border-left: 1px solid #dcdee2;
        width: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ed4014;
        cursor: pointer;
    }

    &.item_3 {
        border: 1px solid #ffd77a;
        background-color: #fff9e6;
    }
    &.is-exclude{
        border: 1px solid #ffb08f !important;
        background-color: #ffefe6 !important;
    }
}

.pointer {
    cursor: pointer;
}
::v-deep .drag-ghost{
    border-color: #999!important;
    border-style: dashed!important;
    background-color: #ccc!important;
    position: relative;
}
.data_select {
    overflow: hidden;
    position: relative;
    height: 160px;
    &_list {
        padding: 5px 0;
        position: absolute;
        inset: 0;
        z-index: 0;
    }

    &_item {
        border-bottom: 1px solid #dcdee2;
        display: flex;
        align-items: center;
        &:first-child {
            border-top: 1px solid #dcdee2;
        }
        .item_name {
            font-weight: bold;
        }

        .item_list {
            flex: 1;
            width: 0;
            display: flex;
            align-items: center;
            margin-left: 10px;
            height: 34px;

        }

        &:nth-child(3) {
            .select_item {
                border: 1px solid #ffd77a;
                background-color: #fff9e6;
            }
        }

        .temp_select_del {
            color: #ed4014;
            cursor: pointer;
        }
    }

    &_handle {
        margin-top: 5px;
    }
    .ver-middle {
        line-height: 28px;
        vertical-align: middle;
        margin: 0 6px;
    }
    .pointer-icon{
        font-size: 18px;
        vertical-align: -3px;
        &:hover {
            color: #409EFF;
        }
    }
}
.data_select_handle {
    padding-top: 4px;
    display: flex;
    justify-content: space-between;
}
</style>